module.exports = __webpack_public_path__ + "static/epanek-46bcbf7317e09305d36a86de7fe57c98.png";